// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebarBox__NXksF {
  height: 100%;
  background: var(--overlay-primary);
  overflow-x: hidden;
  z-index: 10;
}

.Sidebar_sidebar__vQYtl {
  border: 1px solid var(--border-tertiary);
  background: var(--background-primary);
  padding: 15px;
  height: 100%;
  max-width: 280px;
  width: 64px;
}
.Sidebar_sidebar_logoIcon__F9lv\\+ {
  margin-bottom: 20px;
}
.Sidebar_sidebar_tabBox__RmnO6 {
  height: calc(100% - 46px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.Sidebar_sidebar_topTab__5vjxx {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.Sidebar_sidebar_topTab__5vjxx a {
  position: relative;
}
.Sidebar_sidebar_tab__qYJg\\+ {
  height: 32px;
  padding: 7px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary);
}
.Sidebar_sidebar_tab__qYJg\\+ span {
  display: flex;
  align-items: center;
}
.Sidebar_sidebar_tab__qYJg\\+:hover {
  background: var(--background-hover);
  color: var(--text-link);
}
.Sidebar_sidebar_tab__qYJg\\+:active {
  background: var(--background-active);
  color: var(--text-link);
}
.Sidebar_sidebar_tabExpanded__wAwRc {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.Sidebar_sidebar_icon__hahHJ {
  position: relative;
}
.Sidebar_sidebar_icon__hahHJ::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 15px;
  z-index: 100;
  width: 5px;
  height: 5px;
  background: var(--support-danger-default);
  border-radius: 100%;
}
.Sidebar_sidebar_unreadMsg__8snHs {
  color: var(--text-on-color);
  text-align: center;
  display: inline-flex;
  padding: 1px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background: var(--support-danger-default);
  font-size: 11px;
}

.Sidebar_unreadCount__PsQB3 {
  position: absolute;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: var(--support-danger-default);
  color: white;
  font-size: 0.8em;
  padding-left: 4px;
  padding-right: 4px;
  height: 15px;
  border-radius: 30px;
  top: 2px;
  left: 16px;
}
.Sidebar_unreadCount__PsQB3 > span {
  display: flex;
  align-items: center;
  font-size: 0.8em;
}

.Sidebar_active_tab__nTy3P {
  background: var(--background-active);
  color: var(--text-link);
}
.Sidebar_active_tab__nTy3P:hover {
  background: var(--background-active);
  color: var(--text-link);
}
.Sidebar_active_tab__nTy3P:active {
  background: var(--background-active);
  color: var(--text-link);
}

.Sidebar_spinnerMain__Gv8SZ {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 10px;
  background: var(--border-tertiary);
  cursor: default;
}
.Sidebar_spinnerMain__Gv8SZ > p {
  font-size: 0.9em;
  width: 0px;
  overflow: hidden;
  cursor: default;
  transition: 0.3s;
  color: var(--text-secondary);
}
.Sidebar_spinnerMain__Gv8SZ:hover p {
  width: unset;
  margin-left: 10px;
}

@media only screen and (max-width: 500px) {
  .Sidebar_sidebar__vQYtl,
  .Sidebar_sidebarBox__NXksF {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;AACD;;AAEA;EACC,wCAAA;EACA,qCAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AACD;AAGC;EACC,mBAAA;AADF;AAIC;EACC,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFF;AAKC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;AAKE;EACC,kBAAA;AAHH;AAOC;EACC,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AANF;AAQE;EACC,aAAA;EACA,mBAAA;AANH;AASE;EACC,mCAAA;EACA,uBAAA;AAPH;AAUE;EACC,oCAAA;EACA,uBAAA;AARH;AAYC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;AAVF;AAaC;EACC,kBAAA;AAXF;AAaE;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,mBAAA;AAXH;AAeC;EACC,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;AAbF;;AAiBA;EACC,kBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AAdD;AAgBC;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AAdF;;AAkBA;EACC,oCAAA;EACA,uBAAA;AAfD;AAiBC;EACC,oCAAA;EACA,uBAAA;AAfF;AAiBC;EACC,oCAAA;EACA,uBAAA;AAfF;;AAmBA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;AAhBD;AAkBC;EACC,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAhBF;AAoBE;EACC,YAAA;EACA,iBAAA;AAlBH;;AAuBA;EACC;;IAEC,aAAA;EApBA;AACF","sourcesContent":[".sidebarBox {\n\theight: 100%;\n\tbackground: var(--overlay-primary);\n\toverflow-x: hidden;\n\tz-index: 10;\n}\n\n.sidebar {\n\tborder: 1px solid var(--border-tertiary);\n\tbackground: var(--background-primary);\n\tpadding: 15px;\n\theight: 100%;\n\tmax-width: 280px;\n\twidth: 64px;\n\t// uncomment the line below to make the sidebar animation smoother\n\t// transition: all 0.3s;\n\n\t&_logoIcon {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t&_tabBox {\n\t\theight: calc(100% - 46px);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t}\n\n\t&_topTab {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 10px;\n\n\t\ta {\n\t\t\tposition: relative;\n\t\t}\n\t}\n\n\t&_tab {\n\t\theight: 32px;\n\t\tpadding: 7px;\n\t\tborder-radius: 8px;\n\t\tfont-size: 14px;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tcolor: var(--text-primary);\n\n\t\tspan {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--background-hover);\n\t\t\tcolor: var(--text-link);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var(--background-active);\n\t\t\tcolor: var(--text-link);\n\t\t}\n\t}\n\n\t&_tabExpanded {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&_icon {\n\t\tposition: relative;\n\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0px;\n\t\t\tleft: 15px;\n\t\t\tz-index: 100;\n\t\t\twidth: 5px;\n\t\t\theight: 5px;\n\t\t\tbackground: var(--support-danger-default);\n\t\t\tborder-radius: 100%;\n\t\t}\n\t}\n\n\t&_unreadMsg {\n\t\tcolor: var(--text-on-color);\n\t\ttext-align: center;\n\t\tdisplay: inline-flex;\n\t\tpadding: 1px 6px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: 15px;\n\t\tbackground: var(--support-danger-default);\n\t\tfont-size: 11px;\n\t}\n}\n\n.unreadCount {\n\tposition: absolute;\n\tdisplay: flex !important;\n\talign-items: center !important;\n\tjustify-content: center !important;\n\tbackground: var(--support-danger-default);\n\tcolor: white;\n\tfont-size: 0.8em;\n\tpadding-left: 4px;\n\tpadding-right: 4px;\n\theight: 15px;\n\tborder-radius: 30px;\n\ttop: 2px;\n\tleft: 16px;\n\n\t> span {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tfont-size: 0.8em;\n\t}\n}\n\n.active_tab {\n\tbackground: var(--background-active);\n\tcolor: var(--text-link);\n\n\t&:hover {\n\t\tbackground: var(--background-active);\n\t\tcolor: var(--text-link);\n\t}\n\t&:active {\n\t\tbackground: var(--background-active);\n\t\tcolor: var(--text-link);\n\t}\n}\n\n.spinnerMain {\n\tposition: fixed;\n\tbottom: 20px;\n\tright: 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 10px 14px;\n\tborder-radius: 10px;\n\tbackground: var(--border-tertiary);\n\tcursor: default;\n\n\t> p {\n\t\tfont-size: 0.9em;\n\t\twidth: 0px;\n\t\toverflow: hidden;\n\t\tcursor: default;\n\t\ttransition: 0.3s;\n\t\tcolor: var(--text-secondary);\n\t}\n\n\t&:hover {\n\t\tp {\n\t\t\twidth: unset;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n}\n\n@media only screen and (max-width: 500px) {\n\t.sidebar,\n\t.sidebarBox {\n\t\tdisplay: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarBox": `Sidebar_sidebarBox__NXksF`,
	"sidebar": `Sidebar_sidebar__vQYtl`,
	"sidebar_logoIcon": `Sidebar_sidebar_logoIcon__F9lv+`,
	"sidebar_tabBox": `Sidebar_sidebar_tabBox__RmnO6`,
	"sidebar_topTab": `Sidebar_sidebar_topTab__5vjxx`,
	"sidebar_tab": `Sidebar_sidebar_tab__qYJg+`,
	"sidebar_tabExpanded": `Sidebar_sidebar_tabExpanded__wAwRc`,
	"sidebar_icon": `Sidebar_sidebar_icon__hahHJ`,
	"sidebar_unreadMsg": `Sidebar_sidebar_unreadMsg__8snHs`,
	"unreadCount": `Sidebar_unreadCount__PsQB3`,
	"active_tab": `Sidebar_active_tab__nTy3P`,
	"spinnerMain": `Sidebar_spinnerMain__Gv8SZ`
};
export default ___CSS_LOADER_EXPORT___;
